export default "__VITE_ASSET___0O8ARqa__";